import { Person } from '@appTypes/essential-ui/Person';
import { RenderPosition } from '@enums/RenderPosition';

export const exhaustiveCheck = (arg: never) => {
  throw new Error(`Didn't expect to get here...`);
};

export const getPersonFullName = (person: Person) => `${person.firstName} ${person.lastName}`;

export const scrollToTopOnLoad = () => {
  window.scrollTo({
    top: 0,
    behavior: 'instant',
  });
};

export const truncateText = (text: string, max: number) =>
  text.length > max ? `${text.substring(0, max)}\u2026` : text;

export const getRenderposition = (
  elementHeight: number,
  differeceHeight: number = 50,
): RenderPosition => {
  const willItFit =
    elementHeight <=
    (window.innerHeight || document.documentElement.clientHeight) - differeceHeight;
  return willItFit ? RenderPosition.Bottom : RenderPosition.Top;
};

export const groupBy = <T>(items: T[], key: string): {} => {
  return items.reduce(function (rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
};

// Case-sensitive version
export const compareValuesCaseSensitive = (a: string | number, b: string | number) =>
  String(a).localeCompare(String(b), undefined, { numeric: true });

// For numbers only (faster)
export const compareNumbersAscending = (a: number, b: number) => a - b;
